const hex = (value: number) => Math.floor(value).toString(16);

export const generateObjectId = () => {
  return hex(new Date().getTime() / 1000) + ' '.repeat(16).replace(/./g, () => hex(Math.random() * 16));
};
